import http from "../http-common";
import authHeader from '../auth-header';

export default class FacturaService {

    grabarFactura(json){
        return http.post(`jaapzproceso/factura/grabarfactura`, json, { headers: authHeader() });
    }

    imprimirFactura(idfactura){
        return http.get(`jaapzproceso/factura/imprimirfactura/${idfactura}`, { headers: authHeader(), responseType: 'arraybuffer' });
    }

    consultarFacturaCliente(idcliente){
        return http.get(`jaapzproceso/factura/consultarfacturacliente/${idcliente}`, { headers: authHeader() });
    }

    eliminarFacturaPorId(id){
        return http.get(`jaapzproceso/factura/eliminarfacturaporid/${id}`, { headers: authHeader() });
    }

    imprimirRecaudacionDiaria(fecha){
        return http.get(`jaapzproceso/factura/imprimirrecaudaciondiaria/${fecha}`, { headers: authHeader(), responseType: 'arraybuffer' });
    }
}